/**
 * Convert celsius to fahrenheit
 * @param {Number} celsius Temperature in celsius
 * @returns {Number} Temperature in fahrenheit
 */
const celsiusToFahrenheit = (celsius) => (celsius * 9) / 5 + 32;

/**
 * Convert fahrenheit to celsius
 * @param {Number} fahrenheit Temperature in fahrenheit
 * @returns {Number} Temperature in celsius
 */
const fahrenheitToCelsius = (fahrenheit) => ((fahrenheit - 32) * 5) / 9;

module.exports = {
  celsiusToFahrenheit,
  fahrenheitToCelsius,
};
